import { UseQueryResult } from '@tanstack/react-query';
import { useEffect } from 'react';
import { downloadFile } from '../../../utils/commonUtils';
import S from './ReportRequestStyles';

type Props = {
  name?: string;
  endpoint: (fleetId: string, query: string) => UseQueryResult<any>;
  query: string;
  fleetId: string;
  onDownload?: any;
};

function File({
  name,
  endpoint,
  query,
  fleetId,
  onDownload,
}: Props): JSX.Element {
  const { data: file, isLoading, isError } = endpoint(fleetId, query);

  useEffect(() => { }, [file]);

  const downloadFileOnClick = ():void => {
    downloadFile(file, name || 'Report', 'text/csv;charset=utf-8');
    onDownload();
  };

  return (
    <S.Download>
      {!isError && (
        <p>{(isLoading || !file) && !isError ? 'Report is preparing...' : `Report "${name}" was created!`}</p>
      )}
      {isError && (
        <p className="error">Failed to request report!</p>
      )}
      {
        file && (
          <button type="button" onClick={downloadFileOnClick}>Press to Download</button>
        )
      }
    </S.Download>

  );
}

export default File;
